import { render, staticRenderFns } from "./TagAdd.vue?vue&type=template&id=1a47a79c&scoped=true"
import script from "./TagAdd.vue?vue&type=script&lang=js"
export * from "./TagAdd.vue?vue&type=script&lang=js"
import style0 from "./TagAdd.vue?vue&type=style&index=0&id=1a47a79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47a79c",
  null
  
)

export default component.exports